import { CDN_SERVER_DOMAIN } from "@/constants";

export const FLY_SPEED = 1.5;
export const DEFAULT_TRANSITION_DURATION = 1000;
export const MIN_ZOOM = 0;
export const MAX_ZOOM = 23;
export const MAX_ZOOM_IMDF_EDITOR = 30;
export const INITIAL_ZOOM = 2;
export const AR_NAVIGATION_ZOOM = 18;
export const MIN_PITCH = 0;
export const MAX_PITCH = 60;
export const INITIAL_PITCH = 30;
export const MIN_BEARING = -180;
export const MAX_BEARING = 180;
export const INITIAL_BEARING = 0;
export const MAPBOXSTYLE_LIGHT = `https://${CDN_SERVER_DOMAIN}/uploads/mapstyles/default/light-v10.json`;
export const MAPBOXSTYLE_DARK = `https://${CDN_SERVER_DOMAIN}/uploads/mapstyles/default/dark-v10.json`;
export const MAPBOXSTYLE_HIGHT_CONTRAST_DARK = `https://${CDN_SERVER_DOMAIN}/uploads/mapstyles/default/hc-dark.json`;
export const MAPBOXSTYLE_HIGHT_CONTRAST_LIGHT = `https://${CDN_SERVER_DOMAIN}/uploads/mapstyles/default/hc-light.json`;
export const DEFAULT_PADDING = 1;
export const MIN_STEP_FITTING_ANIMATION_TIME = 1500;
export const MAX_STEP_FITTING_ANIMATION_TIME = 5000;
export const DEFAULT_GLYPH_SOURCE = `https://${CDN_SERVER_DOMAIN}/uploads/fonts/default/{fontstack}/{range}.pbf`;

export const GEOJSON_OPACITY = 1;
export const POLYGON_OPACITY = 255;
export const EXTRUSION_OPACITY = 255;
export const WIREFRAME_OPACITY = 150;
export const POLYGON_MARGIN = 0.1;
export const EXTRUDE_POLYGONS = true;

export const BASEMAP_STYLE_PRESETS = [
  { label: "light", value: MAPBOXSTYLE_LIGHT },
  { label: "dark", value: MAPBOXSTYLE_DARK },
];
